import React from 'react';
import { AlertTriangle, X, ArrowLeft } from 'lucide-react';
import { ImpersonationService } from '../services/impersonationService';

export const ImpersonationBanner: React.FC = () => {
  const status = ImpersonationService.getImpersonationStatus();

  if (!status.isImpersonating) {
    return null;
  }

  const handleStopImpersonation = async () => {
    const result = await ImpersonationService.stopImpersonation();
    if (result.success) {
      // Reload to apply the changes
      window.location.reload();
    } else {
      alert(`Failed to stop impersonation: ${result.message}`);
    }
  };

  return (
    <div className="bg-orange-500 text-white px-4 py-3 flex items-center justify-between shadow-lg z-50">
      <div className="flex items-center space-x-3">
        <AlertTriangle className="h-5 w-5 text-orange-200" />
        <div>
          <span className="font-medium">🎭 Impersonating User</span>
          <span className="ml-2 text-orange-100">
            {status.targetUser} • {status.duration}
          </span>
        </div>
      </div>
      
      <div className="flex items-center space-x-2">
        <span className="text-orange-100 text-sm hidden sm:inline">
          Super Admin Session Active
        </span>
        <button
          onClick={handleStopImpersonation}
          className="flex items-center space-x-1 px-3 py-1 bg-orange-600 hover:bg-orange-700 rounded-lg transition-colors text-sm font-medium"
        >
          <ArrowLeft className="h-4 w-4" />
          <span>Exit Impersonation</span>
        </button>
      </div>
    </div>
  );
}; 